import { isUuid } from '../../utils/format';

export const ADMITTED_SESSION_KEY = 'evault.custodian.sessionAdmittedPackageIds';
export const ADMITTED_SESSION_EVENT = 'evault:custodian-admitted-session';
const MAX_IDS = 25;

function readRawIds() {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(ADMITTED_SESSION_KEY) || '[]');
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((value) => isUuid(value));
  } catch {
    return [];
  }
}

function writeIds(ids) {
  sessionStorage.setItem(ADMITTED_SESSION_KEY, JSON.stringify(ids));
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(ADMITTED_SESSION_EVENT));
  }
}

export function listRememberedAdmittedPackageIds() {
  return readRawIds();
}

export function rememberAdmittedPackageId(packageId) {
  if (!isUuid(packageId)) return;
  const ids = readRawIds().filter((id) => id !== packageId);
  writeIds([packageId, ...ids].slice(0, MAX_IDS));
}

export function forgetAdmittedPackageId(packageId) {
  if (!isUuid(packageId)) return;
  writeIds(readRawIds().filter((id) => id !== packageId));
}
